/** Returns whether React Query Devtools should render in the current Vite mode. */
export function shouldRenderReactQueryDevtools(): boolean {
  return import.meta.env.DEV;
}
